var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-content promotion-tab-content" }, [
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("top"),
        attrs: { id: "top" }
      },
      [
        _c("top", {
          attrs: { currentTab: _vm.tab },
          on: { checkData: _vm.checkData }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("promotion-request"),
        attrs: { id: "promotion-request" }
      },
      [_c("promotion-request", { attrs: { currentTab: _vm.tab } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("promotion-info"),
        attrs: { id: "promotion-info" }
      },
      [_c("promotion-info", { attrs: { currentTab: _vm.tab } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1af2c2d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af2c2d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/promotion/TabContent.vue
// module id = null
// module chunks = 